// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AddonBinStationStatus } from './addon-bin-station-status';
import { AddonBinStatus } from './addon-bin-status';
import { AddonStation } from './addon-station';
import { ItemDetailAddon } from './item-detail-addon';
import { JoHeader } from './jo-header';
import { AddonBinStatusEnum } from './enums';
import { AddonBinStationStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AddonBin extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK account */
  accountId!: number;
  /** Enum FK addonBinStatus */
  addonBinStatusId!: AddonBinStatusEnum;
  /** String(512) */
  aggregateGroupingKey!: string;
  /** Enum FK currentAddonBinStationStatus */
  currentAddonBinStationStatusId?: AddonBinStationStatusEnum;
  /** Int32 FK currentAddonStation */
  currentAddonStationId?: number;
  /** Int32 FK joHeader */
  joHeaderId?: number;
  /** Int32 FK pendingAddonStation */
  pendingAddonStationId?: number;
  /** Int32 */
  priorityOrder!: number;
  /** FK accountId */
  account!: Account;
  /** FK addonBinStatusId */
  addonBinStatus!: AddonBinStatus;
  /** FK currentAddonBinStationStatusId */
  currentAddonBinStationStatus!: AddonBinStationStatus;
  /** FK currentAddonStationId */
  currentAddonStation!: AddonStation;
  /** Inv FK addonBinId */
  itemDetailAddons!: ItemDetailAddon[];
  /** FK joHeaderId */
  joHeader!: JoHeader;
  /** FK pendingAddonStationId */
  pendingAddonStation!: AddonStation;
}

